import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';

const GeneralTerms = () => {
    const { t } = useTranslation(['generalTermsAndConditionsOfUse']);
    const data = t('body');
    const getSanitizedData = () => ({
        __html: DOMPurify.sanitize(data)
      });
    
    return (
        <div 
        dangerouslySetInnerHTML={getSanitizedData()}
        />
    );
};

export { GeneralTerms };